import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertBody, AlertDescription, AlertIcon, AlertTitle } from '../../design-system/alert';
import { BudgetPeriod } from '../../entities/awards';
import { useCurrentCompany } from '../../lib/who-am-i';

type BudgetEstimateFixedProps = {
	amount: number | null;
	budgetPerPeriod: number | null;
	period: BudgetPeriod;
};

export const BudgetEstimateFixed: FC<BudgetEstimateFixedProps> = ({ amount, budgetPerPeriod, period }) => {
	const { t } = useTranslation('awards', { keyPrefix: 'form' });
	const company = useCurrentCompany();

	if (!amount || !budgetPerPeriod) {
		return null;
	}

	const count = Math.trunc(budgetPerPeriod / amount);
	const budgetInCurrency = Math.trunc(budgetPerPeriod / company.budget.exchange_rate);
	const awardAmountInCurrency = Math.trunc(amount / company.budget.exchange_rate);

	return (
		<Alert status="info" size="sm">
			<AlertIcon />
			<AlertBody>
				<AlertTitle>{t('estimateTitle', { amount: budgetInCurrency, context: period })}</AlertTitle>
				<AlertDescription>{t('estimateFixedDescription', { amount: awardAmountInCurrency, count })}</AlertDescription>
			</AlertBody>
		</Alert>
	);
};
